import controller from './doctor-filter.controller';
import template from './doctor-filter.html';

const DoctorFilterComponent = {
	bindings: {
		healthIssue: '<',
		selectedHealthIssue: '<',
		selectedGender: '<',
		selectedDateRange: '<',
		languages: '<',
		selectedLanguage: '<',
		childrenOption: '<',
		timeBeforeOption: '<',
		timeAfterOption: '<',
		addressSummary: '<',
		sortFields: '<',
		sortBy: '<',
		language: '<',
		onChangeFilter: '&',
		onChangeSorting: '&',
	},
	controller,
	template
};
export default DoctorFilterComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/doctor-filter/doctor-filter.component.js